import { css } from 'emotion';

export const root = isMobile =>
  isMobile
    ? css`
        width: 100vw;
        justify-content: space-evenly;
        bottom: 0;
        padding-right: 70px;
        height: 96px;
        padding-left: 10px;
        background-image: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0),
          rgba(0, 0, 0, 0.2) 26%,
          rgba(0, 0, 0, 0.51) 75%,
          #000000
        );
        align-items: center;
        transition: 0.3s transform ease-out;
        transform: translate3d(0, 0px, 0);
        &.hideToBottom {
          transform: translate3d(0, 400px, 0);
          transition: 0.3s transform ease-in;
        }
      `
    : css`
        bottom: 20px;
        height: 0px;
        align-items: flex-end;
        transition: right 0.3s;
        opacity: 0.6;
        &:hover {
          opacity: 1;
        }
      `;

export const commonMediaClass = right => css`
  position: fixed;
  right: ${right}px;
  z-index: 100;
  display: flex;
`;

export const button = css`
  margin-right: 20px;

  svg {
    height: 24px;
    width: 24px;
  }
`;

export const localUserVideo = (isMobile, right) =>
  isMobile
    ? css`
        position: absolute;
        bottom: 91px;
        right: ${right}px;
        & video {
          max-width: 150px;
        }
      `
    : css`
        & video {
          width: 240px;
        }
      `;

export const showActionBtn = css`
  position: fixed;
  bottom: 0;
  left: 29px;
  z-index: 100;
  transition: 0.3s ease-in;
  transform: translate3d(0, 100px, 0);
  &.showFromBottom {
    transform: translate3d(0, -24px, 0);
    transition: 0.3s ease-out;
  }
`;
